import LandingPage from './LandingPage';

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/LandingPage/index.js